import { createFileRoute } from '@tanstack/react-router';
import { MyInstalls } from '@/components/marketplace';

export const Route = createFileRoute('/_dashboard/marketplace/my-installs')({
  component: MyInstallsPage,
});

function MyInstallsPage() {
  return <MyInstalls />;
}
